import { Box } from '@factorialco/deprecated-design-system'
import { Text } from '@factorialco/deprecated-design-system'
import { F0Icon } from '@factorialco/f0-react'
import { Pencil } from '@factorialco/f0-react/icons/app'

interface CustomWidgetHeaderButton {
  label: string
  onClick: () => void
}

export default function CustomWidgetHeaderButton({ label, onClick }: CustomWidgetHeaderButton) {
  return (
    <Box
      width="fit-content"
      paddingX="s8"
      paddingY="s1"
      borderRadius={{ all: 'abs008' }}
      position="absolute"
      style={{
        top: '15px',
        right: '10px',
        border: '1px solid hsla(213, 87%, 15%, 0.14)',
      }}
      onClick={onClick}
    >
      <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center">
        <Box width="s24" height="s24" alignItems="center" justifyContent="center">
          <F0Icon icon={Pencil} size="sm" />
        </Box>

        <Text size="200" weight="semibold">
          {label}
        </Text>
      </Box>
    </Box>
  )
}
